module.exports = __webpack_public_path__ + "static/media/Abroad Job Opportunities.6ae25c34.png";